import { jsx } from "react/jsx-runtime";
import React from "react";
import { string, bool, node, arrayOf, oneOfType } from "prop-types";
import cx from "classnames";
const getValidity = (valid) => {
  if (valid === true) {
    return "success";
  }
  if (valid === false) {
    return "error";
  }
  if (valid === "warning" || valid === "success" || valid === "error") {
    return valid;
  }
  return "";
};
const propTypes = {
  prefix: string,
  className: string,
  children: oneOfType([arrayOf(node), node]),
  id: string,
  shouldValidate: bool,
  valid: oneOfType([bool, string]),
  textOnly: bool
};
const HelperText = (props) => {
  const {
    prefix = "",
    children,
    className,
    shouldValidate,
    valid = false,
    textOnly = false,
    ...otherProps
  } = props;
  const validity = getValidity(valid);
  const baseClass = `${prefix}helper-text`;
  const cssStyles = cx(
    baseClass,
    shouldValidate && validity !== "" && `${baseClass}--${validity}`,
    textOnly && `${baseClass}--text-only`,
    className
  );
  return /* @__PURE__ */ jsx(
    "span",
    {
      ...otherProps,
      className: cssStyles,
      children
    }
  );
};
HelperText.propTypes = propTypes;
HelperText.displayName = "HelperText";
var HelperText_default = HelperText;
export {
  HelperText,
  HelperText_default as default,
  propTypes
};
